<template>
  <v-card ref="content" class="card-wrap">
    <v-card-title>{{ $t('alert.ttl.ow.list') }}</v-card-title>
    <div class="box">
      <!-- eslint-disable-next-line prettier/prettier -->
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="alerts"
        item-key="id"
        :items-per-page="paging.rowsPerPage"
        :loading="loading"
        :height="params.height - 80"
        class="elevation-1 content"
        fixed-header dense hide-default-footer
      >
        <template v-slot:item.level="{ item }">
          <span>
            <v-icon class="mr-1" :color="colors[item.level.value]" x-small>{{ icons[item.level.value] }}</v-icon>
          </span>
          {{ item.level.name }}
        </template>
        <template v-slot:item.dateTime="{ item }">
          {{ item.dateTime | format('yyyy-MM-dd HH:mm:ss') }}
        </template>
        <template v-slot:item.target="{ item }"> {{ item.systemId }}_{{ item.instShortAlias == '' ? item.instanceId : item.instShortAlias }} </template>
        <template v-slot:item.confirmed="{ item }">
          {{ item.confirmed ? `${$t('analysis.alert.confirm')} (${item.confirmedUser})` : item.failback ? $t('analysis.alert.failover') : '' }}
        </template>
        <template v-slot:footer>
          <pagination :paging.sync="paging" :length="length" :disabled="loading"></pagination>
        </template>
      </v-data-table>
    </div>
  </v-card>
</template>

<script>
import { api } from '@/api/common/instances';
export default {
  props: {
    params: {
      type: Object,
      required: true,
    },
    timestamp: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      alerts: [],
      selected: [],
      paging: { page: 1, rowsPerPage: 20 },
      length: 0,
      colors: { 0: '#00ff00', 1: '#0085ff', 4: '#ffdd00', 5: '#ff0000' },
      icons: { 0: 'mdi-restore-alert', 1: 'mdi-information-outline', 4: 'mdi-alert', 5: 'mdi-alert-remove' },
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t('analysis.alert.level'), value: 'level', width: '10%' },
        { text: this.$t('analysis.alert.datetime'), value: 'dateTime', width: '18%' },
        { text: this.$t('analysis.alert.target'), value: 'target', width: '10%' },
        { text: this.$t('analysis.alert.description'), value: 'message' },
      ];
    },
  },
  watch: {
    paging: {
      deep: true,
      handler() {
        this.fetchAlerts();
      },
    },
    params: {
      deep: true,
      handler() {
        this.resetPaging();
      },
    },
    timestamp: {
      handler() {
        this.fetchAlerts();
      },
    },
  },
  methods: {
    resetPaging() {
      this.paging = { page: 1, rowsPerPage: this.paging.rowsPerPage };
    },
    async fetchAlerts() {
      if (this.loading) return;
      this.loading = true;
      const params = {
        systemIds: this.params.sstmId,
        beginDateTime: this.timestamp - 5 * 1000,
        endDateTime: this.timestamp + 5 * 1000,
        page: this.paging.page,
        limit: this.paging.rowsPerPage,
      };
      // eslint-disable-next-line prettier/prettier
      const { data: { items, pagination } } = await api.get('/alerts', { params });
      this.alerts = items;
      this.length = pagination.totalCount;
      this.loading = false;
    },
  },
  created() {
    this.fetchAlerts();
  },
};
</script>

<style lang="scss" scoped>
.v-data-table {
  border-radius: 0px;
}
</style>
